import Lottie from 'lottie-react';
import { useState, useEffect, FC } from 'react';
import Webcam from 'webcamjs';
import GreenTickAnimation from '../Json/GreenTickAnimation.json';

const SignUp: FC<{ onSwitch: () => void }> = ({ onSwitch }) => {
  const [formData, setFormData] = useState({ firstName: '', lastName: '', imageData: '' });
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isRegister, setIsRegister] = useState(false);
  const baseUrl = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    const setupWebcam = async () => {
      Webcam.set({
        width: 320,
        height: 240,
        image_format: 'jpeg',
        jpeg_quality: 90,
      });

      try {
        await navigator.mediaDevices.getUserMedia({ video: true });
        Webcam.attach('#my_camera');
      } catch (error) {
        setErrorMessage('Could not access the webcam. Please allow camera permissions in your browser.');
      }
    };

    setupWebcam();

    return () => {
      Webcam.reset();
    };
  }, []);

  const takeSnapshot = () => {
    setIsLoading(true);
    Webcam.snap((data_uri) => {
      setFormData((prev) => ({ ...prev, imageData: data_uri }));
      handleSignUp(data_uri);
    });
  };

  const handleSignUp = async (data_uri: string) => {
    const params = {
      firstName: formData.firstName,
      lastName: formData.lastName,
      image: data_uri.replace('data:image/jpeg;base64,', ''),
    };

    try {
      await fetch(`${baseUrl}/signup`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(params),
      });
      setIsLoading(false);
      setIsRegister(true);
    } catch (error) {
      setErrorMessage('Error during signup.');
      setIsLoading(false);
    }
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    takeSnapshot();
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <div className="webcam-wrapper">
      {!isRegister ? (
        <>
          <div id="my_camera" className="camera-container" />
          {errorMessage && <p className="error-text">{errorMessage}</p>}
          <form onSubmit={handleSubmit} className="auth-form">
            <input
              className="text-input-field"
              type="text"
              name="firstName"
              placeholder="First Name"
              value={formData.firstName}
              onChange={handleInputChange}
              required
            />
            <input
              className="text-input-field"
              type="text"
              name="lastName"
              placeholder="Last Name"
              value={formData.lastName}
              onChange={handleInputChange}
              required
            />
            <div className="btn-wrapper">
              <button type="submit" className="main-button primary-btn">
                {isLoading ? <span className="spinner" /> : 'Register'}
              </button>
            </div>
          </form>
        </>
      ) : (
        <div className="green-tick-wrapper">
          <Lottie animationData={GreenTickAnimation} loop={true} style={{ width: '200px', height: '200px' }} />
          <h4 className="welcome-text">Your account register successfully!</h4>
        </div>
      )}
      <p className="login-text" onClick={onSwitch}>
        Go to Login
      </p>
    </div>
  );
};

export default SignUp;
